// extracted by mini-css-extract-plugin
export default {"Text":"Fs9ATJNs","text_16_300":"Xj4REiZ_","text_12":"vR0N5_N5","text_14":"OJd6C6f8","text_16":"dNWiG_9w","text_18":"_G0oCSjl","text_20":"btyCD6j7","text_24":"oha5BsUc","text_30":"lWpYmfQg","text_36":"PJCA2PaL","text_16_600":"uP7pImej","text_18_600":"jpK8Pe4g","text_20_600":"H6HrHbec","text_24_600":"drri3tpV","text_26_600":"Fts_RZiC","text_28_600":"PDqbru2e","text_20_700":"vCXpj42m","text_32_600":"t7mKaVhB","positionCenter":"oA3bf3WB"};
    if(module.hot) {
      // 1721069999193
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  